import "./chatButton.scss";
import React, {useCallback, useEffect, useState} from 'react';
import {CloudDownloadOutlined} from "@ant-design/icons";
import CloseChatButton from "../../icons/CloseChatButton";
import ChatButtonIcon from "../../icons/ChatButtonIcon";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {useLocation} from "react-router-dom";


export const ChatButton = () =>

{

    const [isChatVisible, setChatVisible] = useState(false);
    const location: any = useLocation();

    const [isDragging, setIsDragging] = useState(false);
    const [position, setPosition] = useState({ right: 20, bottom: 20 });
    const [relPosition, setRelPosition] = useState({ x: 0, y: 0 });
    const [dragStart, setDragStart] = useState<any>(null);

    const toggleChat = useCallback(() => {
        setChatVisible(!isChatVisible);
    }, [isChatVisible]);
    const onMouseDown = useCallback((e:any) => {
        const { clientX, clientY } = e;
        setDragStart({
            startX: clientX,
            startY: clientY,
            startRight: position.right,
            startBottom: position.bottom
        });
        e.preventDefault();
    }, [position]);

    const onMouseUp = useCallback((e: any) => {
        if (dragStart) {
            // Add a movement threshold (5px) to distinguish between a drag and a click
            const deltaX = Math.abs(e.clientX - dragStart.startX);
            const deltaY = Math.abs(e.clientY - dragStart.startY);

            if (deltaX < 5 && deltaY < 5) {
                toggleChat();
            }
            setDragStart(null);
        }
        e.preventDefault(); 
    }, [dragStart, toggleChat]);

    const _onMouseMove = useCallback((e: any) => {
        if (dragStart) {
            setPosition({
                right: dragStart.startRight - (e.clientX - dragStart.startX),
                bottom: dragStart.startBottom - (e.clientY - dragStart.startY)
            });
            e.preventDefault();
        }
    }, [dragStart]);

    useEffect(() => {
        if (dragStart !== null) {
            document.addEventListener('mousemove', _onMouseMove);
            document.addEventListener('mouseup', onMouseUp);

            return () => {
                document.removeEventListener('mousemove', _onMouseMove);
                document.removeEventListener('mouseup', onMouseUp);
            };
        }
    }, [dragStart, _onMouseMove, onMouseUp]);

    return (
        <>
            <div>
                <button
                    className={"chat-button"}
                    style={{
                        right: `${position.right}px`,
                        bottom: `${position.bottom}px`,
                        cursor: isChatVisible ? 'pointer' : 'grab',
                        zIndex: 1000,
                        transition: 'transform 0.2s ease',
                    }}
                    onMouseDown={onMouseDown}
                >
                    {isChatVisible ? <CloseChatButton /> : <ChatButtonIcon />}
                </button>

                <iframe
                    id="chatIframe"
                    src="https://7essine17.pythonanywhere.com/"
                    allow="clipboard-write"
                    style={{
                        position: 'fixed',
                        bottom: `${position.bottom + 70}px`,
                        right: `${position.right}px`,
                        width: '350px',
                        height: '60%',
                        border: '1px solid rgba(0, 0, 0, 0.1)',
                        zIndex: 999,
                        boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
                        borderRadius: '20px',
                        background: '#fff',
                        // Pre-loading and smooth transition logic
                        opacity: isChatVisible ? 1 : 0,
                        visibility: isChatVisible ? 'visible' : 'hidden',
                        transform: isChatVisible ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.95)',
                        transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
                        pointerEvents: isChatVisible ? 'all' : 'none',
                    }}
                ></iframe>
            </div>
        </>
    );
};